import { CardContent as MuiCardContent, CardContentProps } from '@material-ui/core';

export const CardContent = ({ children, ...rest }: CardContentProps) => {
  return <MuiCardContent {...rest}>{children}</MuiCardContent>;
};
